module.exports = __webpack_public_path__ + "static/media/userPhoto.a8d8ecba.png";